import React from 'react';
import { IStandardDocumentVersionData } from '../../../../../types/order/documents/shared/interfaces';
import { BodyText, IconType, NavigationItem, RotatingIcon } from '../../../../../ui-toolkit';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export interface IPublicationLinksProps {
  isAmericanDigital: boolean;
  document: IStandardDocumentVersionData;
  fetchingStatus: boolean;
  onPublish: (docId: string) => void;
  onUnpublish: (docId: string) => void;
}

export const PublicationLinks: React.FC<IPublicationLinksProps> = ({
  document,
  fetchingStatus,
  onUnpublish,
  isAmericanDigital,
  onPublish,
}) => {
  if (document.clientPublishedAt)
    return <UnpublishLink fetchStatus={fetchingStatus} onUnpublish={onUnpublish} document={document} />;
  return <PublishLink document={document} isAmericanDigital={isAmericanDigital} onPublish={onPublish} />;
};

export const PublishLink: React.FC<{
  document: IStandardDocumentVersionData;
  isAmericanDigital: boolean;
  onPublish: (docId: string) => void;
}> = ({ isAmericanDigital, onPublish, document }) => {
  if (isAmericanDigital) return null;
  return <NavigationItem text={'Publish'} onClick={() => onPublish(document.id)} isInline />;
};

export const UnpublishLink: React.FC<{
  document: IStandardDocumentVersionData;
  fetchStatus: boolean;
  onUnpublish: (docId: string) => void;
}> = ({ document, fetchStatus, onUnpublish }) => (
  <>
    {fetchStatus ? (
      <RotatingIcon type={IconType.Loading} />
    ) : (
      <NavigationItem text={'Unpublish'} onClick={() => onUnpublish(document.id)} isInline />
    )}
    <BodyText>Published On: : {getDateString(DateFormat.hugeDateTime, document.updatedAt, true)}</BodyText>
  </>
);
